export default __webpack_public_path__ + "media/images/badge-level3-size34-2e0c63f82bdcbf9533b875b72d912b3a.png";